export const strategyTitle =
  'FEWESTCALLS - Toca no ramal com o menor número de chamadas concluídas.\nLEASTRECENT - Toca no ramal que foi desligado a mais tempo.\nLINEAR - Toca na ordem que os ramais entraram na fila\nRANDOM - Toca aleatoriamente.\nRINGALL - Toca todos os ramais disponíveis até um atender.\nRRMEMORY - Memoriza de onde parou e passa para o seguinte.';

export const strategyChatTitle =
  'LINEAR - As conversas são ditribuídas pela ordem de login na fila.\nFEWESTCHAT - As conversas são distribuídas para o usuário com menor número de conversas em atendimento.\nFEWESTCHATCLOSED - As conversas são distribuídas para o usuário com o menor número de conversas encerradas.\nNOTDISTRIBUTE - As conversas são distribuidas para todos os usuários logados na fila.';

export const strategyChatTiebreaker =
  'Ordem de login crescente: prioriza quem está há mais tempo logado na fila. \nOrdem de login decrescente: prioriza quem está há menos tempo logado na fila.';

export const limitMaxChatsByQueueTitle =
  'Permite que conversas sejam distribuídas automaticamente, respeitando o limite definido para cada fila. Caso esteja desabilitado, será considerado o somatório de todas as filas em que o atendente está logado.';

export const strategyOptions = [
  { label: 'FEWESTCALLS', value: 'FEWESTCALLS' },
  { label: 'LEASTRECENT', value: 'LEASTRECENT' },
  { label: 'LINEAR', value: 'LINEAR' },
  { label: 'RINGALL', value: 'RINGALL' },
  { label: 'RRMEMORY', value: 'RRMEMORY' },
  { label: 'RANDOM', value: 'RANDOM' }
];

export const StrategyChat = {
  LINEAR: 'LINEAR',
  FEWEST_CHAT: 'FEWESTCHAT',
  FEWEST_CHAT_CLOSED: 'FEWESTCHATCLOSED',
  RANDOM: 'RANDOM',
  NOT_DISTRIBUTE: 'NOTDISTRIBUTE'
};

export const strategyOptionsChat = [
  { label: 'LINEAR', value: StrategyChat.LINEAR },
  {
    label: 'MENOR NÚMERO DE CHATS EM ATENDIMENTO',
    value: StrategyChat.FEWEST_CHAT
  },
  {
    label: 'MENOR NÚMERO DE CHATS ENCERRADOS',
    value: StrategyChat.FEWEST_CHAT_CLOSED
  },
  {
    label: 'ALEATÓRIO',
    value: StrategyChat.RANDOM
  },
  {
    label: 'NÃO DISTRIBUIR',
    value: StrategyChat.NOT_DISTRIBUTE
  }
];

export const CHAT_OVERFLOW = {
  SEND_MESSAGE_AND_CLOSE: 'SEND_MESSAGE_AND_CLOSE',
  SEND_MESSAGE_AND_TRANSFER: 'SEND_MESSAGE_AND_TRANSFER',
  SEND_MESSAGE_AND_QUEUE_WAIT: 'SEND_MESSAGE_AND_QUEUE_WAIT'
};

export const chatOverflowOptions = [
  {
    label: 'ENVIAR  MENSAGEM E ENCERRAR',
    value: CHAT_OVERFLOW.SEND_MESSAGE_AND_CLOSE
  },
  {
    label: 'ENVIAR MENSAGEM E TRANSFERIR',
    value: CHAT_OVERFLOW.SEND_MESSAGE_AND_TRANSFER
  },
  {
    label: 'ENVIAR MENSAGEM E AGUARDAR NA FILA',
    value: CHAT_OVERFLOW.SEND_MESSAGE_AND_QUEUE_WAIT
  }
];

export const booleanOptions = [
  { label: 'Não', value: 'false' },
  { label: 'Sim', value: 'true' }
];
